/**
 * BUSINESS ADDRESS API — CRUD degli address di un Business.
 *
 * Contratto backend (rest-openapi.yaml, BusinessesResourceImpl):
 *   POST   /business/{businessId}/address                AddressInput -> Address
 *   PATCH  /business/{businessId}/address/{addressId}    AddressInput -> Address
 *   DELETE /business/{businessId}/address/{addressId}                  -> 200
 *
 * Shape di `AddressInput` del backend:
 *   { name?, description?, street?, city?, countryId? (int64),
 *     regionId? (int64), zip?, primary? }
 *
 * `countryId`/`regionId` sono ora accettati grazie ai 2 nuovi endpoint
 * REST `/v1_0/countries` e `/v1_0/country/{countryId}/regions` (cache
 * gestita in `entities/geography`). Le label `country`/`region` in
 * response sono risolte server-side dai 2 ID.
 *
 * `latitude`/`longitude` e i campi `country`/`region` stringa restano
 * read-only server-side (geocoder + lookup), non si mandano in input.
 */

import { httpClient } from '../../api/httpClient';
import type { Address } from '../address/addressTypes';

interface AddressInput {
  name?: string;
  description?: string;
  street?: string;
  city?: string;
  zip?: string;
  primary?: boolean;
  countryId?: number | null;
  regionId?: number | null;
}

const NESTED = (businessId: number) => `/business/${businessId}/address`;

export const businessAddressApi = {
  create: (businessId: number, payload: AddressInput): Promise<Address> =>
    httpClient.post<Address>(NESTED(businessId), payload).then((r) => r.data),

  update: (
    businessId: number,
    addressId: number,
    payload: AddressInput
  ): Promise<Address> =>
    httpClient
      .patch<Address>(`${NESTED(businessId)}/${addressId}`, payload)
      .then((r) => r.data),

  remove: (businessId: number, addressId: number): Promise<void> =>
    httpClient.delete(`${NESTED(businessId)}/${addressId}`).then(() => undefined),
};
